import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { areUserRolesIn } from '../helpers';
import { Roles } from '../constants';

import type { RootState } from '../store';
import type { IClaim } from '../utils/types';

function useClaimPaymentEditable(claim: IClaim) {
  const { user } = useSelector((state: RootState) => state.auth);
  const [isEditable, setIsEditable] = useState<boolean>(false);

  useEffect(() => {
    if (areUserRolesIn(user?.roles, [Roles.Biller]) && !claim.is_invoiceable && !claim.invoice_id) {
      setIsEditable(true);
    } else {
      setIsEditable(false);
    }
  }, [user]);

  return isEditable;
}

export default useClaimPaymentEditable;
